import { DJProfile } from '../../../lib/supabase';

interface FooterProps {
  profile: DJProfile | null;
}

export default function Footer({ profile }: FooterProps) {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="hidden md:grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          {/* Brand */}
          <div>
            {profile?.logo_url ? (
              <img
                src={profile.logo_url}
                alt={profile?.name || 'Logo'}
                className="h-16 w-auto mb-4"
              />
            ) : (
              <img
                src="https://wbaggrbegrkcmiahpejw.supabase.co/storage/v1/object/public/Fotos/logo_white_trans.png"
                alt="Logo"
                className="h-16 w-auto mb-4"
              />
            )}
            <p className="text-gray-400 text-sm">
              {profile?.bio
                ? profile.bio.length > 120
                  ? `${profile.bio.slice(0, 120)}...`
                  : profile.bio
                : 'DJ con mayor proyección en Palma de Mallorca. Reguetón latino, latin tech e indie electrónico.'}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Enlaces</h4>
            <div className="flex flex-col gap-2">
              <button
                onClick={() => scrollToSection('past-events')}
                className="text-gray-400 hover:text-cyan-400 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Eventos
              </button>
              <button
                onClick={() => scrollToSection('gallery')}
                className="text-gray-400 hover:text-cyan-400 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Galería
              </button>
              <button
                onClick={() => scrollToSection('music')}
                className="text-gray-400 hover:text-cyan-400 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Música
              </button>
              <button
                onClick={() => scrollToSection('upcoming-events')}
                className="text-gray-400 hover:text-cyan-400 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Próximos Eventos
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-gray-400 hover:text-cyan-400 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Contacto
              </button>
            </div>
          </div>

        </div>

        {/* Copyright */}
        <div className="border-t border-cyan-500/20 pt-8 text-center text-gray-500 text-sm">
          <p>© 2026 {profile?.name || 'Miki Buades'}. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
